import { BroadcastChannel } from 'broadcast-channel';

const frontendChannel = new BroadcastChannel('aonflow-1');

export default frontendChannel;